export const SkillsData = [
    {
      type: "Frontend",
      list: [
        {
          name: "HTML",
          icon: <i class="devicon-html5-plain colored"></i>,
        },
        {
          name: "CSS",
          icon: <i class="devicon-css3-plain colored"></i>,
        },
        {
          name: "Javascript",
          icon: <i class="devicon-javascript-plain colored"></i>,
        },
        {
          name: "ReactJS",
          icon: <i class="devicon-react-original colored"></i>,
        }
      ],
    },
    {
      type: "Backend",
      list: [
        {
          name: "C++",
          icon: <i class="devicon-cplusplus-plain colored"></i>,
        },
        {
          name: "Python",
          icon: <i class="devicon-python-plain colored"></i>,
        },
        {
          name: "Django",
          icon: <i class="devicon-django-plain colored"></i>,
        }
      ],
    },
    {
      type: "Databases",
      list: [
        {
          name: "mySQL",
          icon: <i class="devicon-mysql-plain colored"></i>,
        },
        {
          name: "PostgreSQL",
          icon: <i class="devicon-postgresql-plain colored"></i>,
        },
        {
            name: "PostgreSQL",
            icon: 
            <i class="devicon-mongodb-plain"></i>,
          }
      ],
    }
  ];
